import React from 'react'
import { useState } from 'react'
import Address from '../Address/Address'
import Map from '../Map/Map'
import Details from '../Details/Details'
import Payment from '../Payment/Payment'
import Roof from '../Roof/Roof'

const Home = (props) => {
    let [progress, setProgress] = useState(0)
    const [address, setAddress] = useState(false)
    const [map, setMap] = useState(false)
    const [pay, setPay] = useState(false)
    const [roof, setRoof] = useState(false)

    return (
        <div>
            {
                !address ? <Address {...props} setAddress={setAddress} />
                    :
                    <div>
                        {
                            !map ? <Map {...props} setMap={setMap} setAddress={setAddress} />
                                :
                                <div>
                                    {
                                        progress == 100 && props.selectedValue.val ?
                                            <Payment {...props} />
                                            :
                                            <div>
                                                {
                                                    !roof ?
                                                        <Roof setRoof={setRoof} setMap={setMap} />
                                                        :
                                                        <Details {...props} pay={pay} setPay={setPay} setProgress={setProgress} progress={progress} setRoof={setRoof} />
                                                }
                                            </div>
                                    }
                                </div>

                        }

                    </div>
            }
        </div>
    )
}

export default Home
